exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".steps-content {\n  margin-top: 16px;\n  border: 1px dashed #e9e9e9;\n  border-radius: 2px;\n  background-color: #fafafa;\n  min-height: 200px;\n  text-align: center;\n  padding-top: 20px;\n}\n.steps-action {\n  margin-top: 24px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-pack: end;\n      justify-content: flex-end;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js!./src/pages/activitys/edit-activity/index.less
// module id = 2813
// module chunks = 0